import BaseReducer from '../../../../../../../reducers/base-reducer';
import {
    SingleItemResultReducer,
    singleItemInitialState
} from '../../../../../../../reducers/common/single-item-reducer';
import types from '../../../../../../../actions/types';

class EditReducer extends BaseReducer {
    constructor() {
        super();
        this.initialState = {
            game: singleItemInitialState
        };
        this.ACTION_HANDLERS = {
            ...new SingleItemResultReducer(types.GET_GAME, 'game').ACTION_HANDLERS,
            [types.SAVE_GAME.SUCCESS]: this.onSaveSuccess,
        };
    }

    onSaveSuccess(state, action) {
        return {
            ...state,
            game: {
                ...singleItemInitialState,
                item: action.payload
            }
        };
    }


}

export default new EditReducer().handleActions;



// WEBPACK FOOTER //
// ./src/js/routes/app/routes/games/routes/edit/modules/game-edit-reducer.js